import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";
import {getAllDrivers} from "../Drivers/functions";
import {
    convertAreaObjectToArray,
    getAllTownObject,
    getAreaBlocks,
    getAreaBlocksObject,
    getFilteredAllTownsDividedByAreaBlock
} from "../Towns/functions";

export const getAllCustomers = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'customers', {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getAllCustomersObject = async () => {
    const allCustomers = await getAllCustomers();
    const allCustomersObject = allCustomers.map((customer) => {
        return {
            id : customer.id,
            value : customer.id,
            label : `${customer.person.firstname} ${customer.person.lastname} (${customer.person.activePhonenumber})`
        };
    })

    return allCustomersObject;
}

export const getAllCustomersPersonObject = async () => {
    const allCustomers = await getAllCustomers();
    const allCustomersObject = allCustomers.map((customer) => {
        return {
            id : customer.person.id,
            value : customer.person.id,
            label : `${customer.person.firstname} ${customer.person.lastname} (${customer.person.activePhonenumber})`
        };
    })

    return allCustomersObject;
}

export const getAllCustomersObjectDividedByBlockArea = async () => {
    const allCustomers = await getAllCustomers();
    const allTownsObject = await getAllTownObject();
    const areaBlocks = await getAreaBlocksObject(allTownsObject);
    const allCustomersObject = [] ;
    allCustomers.map((customer) => {
        customer.person.addresses.map((address , index) => {
            allCustomersObject.push( {
                // id : `${customer.person.id}${address.id}`,
                id : customer.id + "_" + address.townId,
                value : customer.id + "_" + address.townId,
                label : `${customer.person.firstname} ${customer.person.lastname} (${customer.person.activePhonenumber})`,
                parentId : address.townId,
            })
        })
    })

    return [...allCustomersObject , ...allTownsObject , ...areaBlocks , {
        id: -1,
        label: "تمامی کاربران",
        value: "ALL_CUSTOMERS"
    }];
}

export const getCustomerById = async (id) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + `customers/${id}`, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}

